import { getAuthCode } from "./getAuthCode";
export const fetchIdeas = async (setIdeas) => {
    try {
      const response = await fetch(process.env.REACT_APP_BACKEND_URL + "/retrieveideas", {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body:JSON.stringify({auth_code:await getAuthCode()})
      });
      const result = await response.json();
      result.sort((a, b) => new Date(b.dateAdded) - new Date(a.dateAdded));
      setIdeas(result);
    } catch (error) {
      console.log(error);
    }
  };